import api from "services/api"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"

export interface ConfirmEmailChangeParams {
  user: string
  email: string
  signature: string
  expires: string
}

export function useConfirmEmailChange(
  params: ConfirmEmailChangeParams,
  config?: UseQueryOptions<unknown>
) {
  const { user, email, signature, expires } = params
  const enabled = !!(user && email && signature && expires)

  return useQuery<unknown>(
    ["account", "email-change", "confirm", params],
    () =>
      api.post("account/email-change/confirm", undefined, {
        params: {
          email,
          expires,
          user,
          signature,
        },
      }),
    {
      enabled,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      meta: { handleError: false },
      ...config,
    }
  )
}
